module.exports = __webpack_public_path__ + "static/media/profile-default.182f6609.svg";